import React from 'react'
import {createRoot} from 'react-dom/client'
import {UIGlobalContextProvider, UserStateProvider} from '../store'

interface UIReactComponentView<T> {
    render: (props: T) => void
    unmount: () => void
}

export type UIReactComponentViewOf<C extends React.ComponentType<any>> = UIReactComponentView<React.ComponentProps<C>>

export const mountUIReactComponent = <T extends object>(
    container: HTMLElement,
    Component: React.ComponentType<T>,
): UIReactComponentView<T> => {
    const root = createRoot(container)

    return {
        render: (props: T) => {
            root.render(<UIGlobalContextProvider>
                <UserStateProvider>
                    <Component {...props} />
                </UserStateProvider>
            </UIGlobalContextProvider>)
        },
        unmount: () => root.unmount(),
    }
}
